var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyBagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5894,
    r: 32,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.83 50.7421C11.5424 50.7421 20.5721 33.2169 27.4324 24.9292H36.9896C43.8499 33.2169 52.1176 50.7421 31.83 50.7421Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1636,
    cy: 38.5073,
    r: 7.34523,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M32.2129 33.6856C28.4674 33.6856 25.4074 36.4045 25.1292 39.8602C25.1193 39.6569 25.1094 39.4621 25.1094 39.2504C25.1094 34.9307 28.2886 31.4326 32.2129 31.4326C36.1372 31.4326 39.3164 34.9392 39.3164 39.2504C39.3164 39.4536 39.3164 39.6569 39.2965 39.8602C39.0184 36.4045 35.9484 33.6856 32.2129 33.6856Z",
    fill: "#1A1E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1549 36.3211C34.0505 35.4064 33.055 35.2011 32.1826 35.1978C31.0418 35.1928 29.9028 36.1725 30.3054 37.214C30.7006 38.2372 32.0503 38.4392 33.0308 38.803C33.4558 38.9599 33.9517 39.1736 34.1884 39.5458C34.4811 40.0081 34.4047 40.5639 34.0822 40.9962C33.7597 41.4285 33.2433 41.6856 32.6598 41.7757C31.7128 41.9226 30.3558 41.7173 30.0258 40.7709C29.9699 40.6107 29.9512 40.4421 29.9587 40.2752",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1642 34.3145V42.7009",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8322 14.9298C34.2752 15.2457 34.524 15.6741 34.524 16.1208C34.8372 15.7339 35.3532 15.4518 35.9583 15.3361C36.5634 15.2205 37.2081 15.2811 37.7506 15.5044C38.2931 15.7277 38.689 16.0956 38.8512 16.5271C39.0133 16.9586 38.9284 17.4183 38.6152 17.8051L35.9583 22.6011H28.366L25.709 17.8051C25.3958 17.4183 25.3109 16.9586 25.4731 16.5271C25.6352 16.0956 26.0311 15.7277 26.5736 15.5044C27.1161 15.2811 27.7609 15.2205 28.366 15.3361C28.9711 15.4518 29.4867 15.7339 29.7999 16.1208C29.7999 15.6741 30.0488 15.2457 30.4918 14.9298C30.9347 14.614 31.5355 14.4365 32.162 14.4365C32.7884 14.4365 33.3892 14.614 33.8322 14.9298Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1465,
    y: 22.5918,
    width: 12.1254,
    height: 3.88672,
    rx: 1,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_14563_2196",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2715 22.5918H26.1465V24.541H38.2715V22.5918Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.2715 22.5918H26.1465V24.541H38.2715V22.5918Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1465 22.5918V20.5918H24.1465V22.5918H26.1465ZM38.2715 22.5918H40.2715V20.5918H38.2715V22.5918ZM38.2715 24.541V26.541H40.2715V24.541H38.2715ZM26.1465 24.541H24.1465V26.541H26.1465V24.541ZM26.1465 22.5918V24.5918H38.2715V22.5918V20.5918H26.1465V22.5918ZM38.2715 22.5918H36.2715V24.541H38.2715H40.2715V22.5918H38.2715ZM38.2715 24.541V22.541H26.1465V24.541V26.541H38.2715V24.541ZM26.1465 24.541H28.1465V22.5918H26.1465H24.1465V24.541H26.1465Z",
    fill: "#1A1E23",
    mask: "url(#path-9-inside-1_14563_2196)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagIcon);
export default __webpack_public_path__ + "static/media/money-bag-icon.b180bb9fe6d7d55b4b6778a58055f9ae.svg";
export { ForwardRef as ReactComponent };